<template>
  <div>
    <v-row v-for="(procedure, index) in procedures" :key="index" no-gutters>
      <v-col>
        <span class="editor-label">{{ index + 1 + '. ' + procedure.grpAuthNm }}</span>
        <v-textarea
          class="editor_bg"
          v-model="procedure.content"
          solo
          no-resize
          auto-grow
          spellcheck="false"
          hide-details="auto"
          :placeholder="`${procedure.grpAuthNm} 절차를 입력하세요`"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Components
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import {
  getAuthGroupProcedure,
  getAuthGroupProcedureSample,
  getAuthGroupProcedureReport,
  saveAuthGroupProcedure,
  deleteAuthGroupProcedure
} from '@/api/procedure/authGroupProcedure.js'

export default {
  mixins: [baseview, iCardRight],
  components: {},
  data() {
    return {
      pageTitle: '권한 그룹(역할) 업무수행',
      initCompId: '',
      rules: [value => !!value || '필수 입력값입니다.'],
      buttonUseList: [
        'btnSample', // 예시보기
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnDelete', // 삭제
        'btnPrint' // 출력
      ],
      procedures: []
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  created() {
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  beforeMount() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  mounted() {},
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    //////////////////////////////////////////////////////////////////////
    // 버튼 이벤트
    //////////////////////////////////////////////////////////////////////
    async btnSample(isNotify) {
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async current => {
        getAuthGroupProcedureSample(isNotify).then(response => {
          if (response.success) {
            this.procedures = response.list
          }
        })
        return
      })
    },
    async btnSearch(isNotify) {
      let param = {
        clntId: this.getClntId()
      }
      getAuthGroupProcedure(param, isNotify).then(response => {
        if (response.success) {
          this.procedures = response.list
        }
      })
    },
    btnSave() {
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.openLoading('saving')
          this.procedures.forEach(procedure => {
            procedure.clntId = this.getClntId()
          })
          saveAuthGroupProcedure(this.procedures, true)
            .then(response => {})
            .finally(() => {
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    btnDelete() {
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.openLoading('deleting')
          this.procedures.forEach(procedure => {
            procedure.clntId = this.getClntId()
          })
          deleteAuthGroupProcedure(this.procedures, true)
            .then(response => {})
            .finally(() => {
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    async btnPrint(type) {
      let data = this.procedures
      // content 필드가 전부 null인지 확인
      const allContent = data.every(procedure => procedure.content === null)
      if (allContent) {
        // 출력할 데이터가 없다는 경고 메시지 표시
        this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
        return
      }
      let param = {
        clntId: this.getClntId(),
        type: type
      }
      this.openLoading()
      getAuthGroupProcedureReport(param)
        .then(response => {
          this.downloadReport(response)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    }
  }
}
</script>

<style lang="scss">
</style>
